'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Stack, Text } from 'ui';
type LoadingMessage = {
  text: string;
  duration: number;
};
interface TransportApiLoaderProps {
  onTimeout?: () => void;
  timeoutDuration?: number;
  loadingMessages?: LoadingMessage[];
}
export default function TransportApiLoader(t0) {
  const $ = _c(81);
  const {
    onTimeout,
    timeoutDuration: t1,
    loadingMessages
  } = t0;
  const timeoutDuration = t1 === undefined ? 20000 : t1;
  const t = useTranslations();
  const [mounted, setMounted] = useState(false);
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [showVideo, setShowVideo] = useState(false);
  const [showText, setShowText] = useState(false);
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);
  const videoRef = useRef(null);
  const messageIntervalRef = useRef(null);
  const timeoutRef = useRef(null);
  let t2;
  if ($[0] !== t) {
    t2 = t("content.trip_planning_routing");
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = {
      text: t2,
      duration: 3000
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("content.trip_planning_expertise");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = {
      text: t4,
      duration: 3000
    };
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t("content.trip_planning_tourism");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = {
      text: t6,
      duration: 3000
    };
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t) {
    t8 = t("content.trip_planning_stops");
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = {
      text: t8,
      duration: 3000
    };
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t) {
    t10 = t("content.trip_planning_optimising");
    $[16] = t;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10) {
    t11 = {
      text: t10,
      duration: 3000
    };
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t) {
    t12 = t("content.trip_planning_availability");
    $[20] = t;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12) {
    t13 = {
      text: t12,
      duration: 3000
    };
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t) {
    t14 = t("content.trip_planning_co2");
    $[24] = t;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t14) {
    t15 = {
      text: t14,
      duration: 3000
    };
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t11 || $[29] !== t13 || $[30] !== t15 || $[31] !== t3 || $[32] !== t5 || $[33] !== t7 || $[34] !== t9) {
    t16 = [t3, t5, t7, t9, t11, t13, t15];
    $[28] = t11;
    $[29] = t13;
    $[30] = t15;
    $[31] = t3;
    $[32] = t5;
    $[33] = t7;
    $[34] = t9;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  const defaultLoadingMessages = t16;
  const messages = loadingMessages && loadingMessages.length > 0 ? loadingMessages : defaultLoadingMessages;
  const videoUrl = loadingMessages && loadingMessages.length > 0 ? process.env.NEXT_PUBLIC_AI_LOADING_ANIMATION_URL || "/videos/ai-travel-planner-animation.mp4" : process.env.NEXT_PUBLIC_LOADING_ANIMATION_URL || "/videos/trip-planning-animation.mp4";
  let t17;
  let t18;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = () => {
      setMounted(true);
      const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
      setPrefersReducedMotion(mediaQuery.matches);
      const handleChange = e => {
        setPrefersReducedMotion(e.matches);
      };
      mediaQuery.addEventListener("change", handleChange);
      return () => mediaQuery.removeEventListener("change", handleChange);
    };
    t18 = [];
    $[36] = t17;
    $[37] = t18;
  } else {
    t17 = $[36];
    t18 = $[37];
  }
  useEffect(t17, t18);
  let t19;
  let t20;
  if ($[38] !== messages || $[39] !== showText) {
    t19 = () => {
      if (!showText) {
        return;
      }
      setCurrentMessageIndex(0);
      const cycleMessages = () => {
        messageIntervalRef.current = setInterval(() => {
          setCurrentMessageIndex(prev => (prev + 1) % messages.length);
        }, messages[0].duration);
      };
      cycleMessages();
      return () => {
        if (messageIntervalRef.current) {
          clearInterval(messageIntervalRef.current);
        }
      };
    };
    t20 = [showText, messages];
    $[38] = messages;
    $[39] = showText;
    $[40] = t19;
    $[41] = t20;
  } else {
    t19 = $[40];
    t20 = $[41];
  }
  useEffect(t19, t20);
  let t21;
  let t22;
  if ($[42] !== onTimeout || $[43] !== timeoutDuration) {
    t21 = () => {
      if (onTimeout) {
        timeoutRef.current = setTimeout(() => {
          onTimeout();
        }, timeoutDuration);
      }
      return () => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      };
    };
    t22 = [onTimeout, timeoutDuration];
    $[42] = onTimeout;
    $[43] = timeoutDuration;
    $[44] = t21;
    $[45] = t22;
  } else {
    t21 = $[44];
    t22 = $[45];
  }
  useEffect(t21, t22);
  let t23;
  let t24;
  if ($[46] !== prefersReducedMotion) {
    t23 = () => {
      if (prefersReducedMotion) {
        setShowVideo(false);
        setShowText(true);
        return;
      }
      setShowVideo(true);
      setShowText(true);
    };
    t24 = [prefersReducedMotion];
    $[46] = prefersReducedMotion;
    $[47] = t23;
    $[48] = t24;
  } else {
    t23 = $[47];
    t24 = $[48];
  }
  useEffect(t23, t24);
  let t25;
  let t26;
  if ($[49] !== messages || $[50] !== prefersReducedMotion || $[51] !== showText || $[52] !== showVideo) {
    t25 = () => {
      const video = videoRef.current;
      if (!video || !showVideo || prefersReducedMotion) {
        return;
      }
      const handleLoadedData = () => {
        if (showText) {
          setCurrentMessageIndex(0);
          if (messageIntervalRef.current) {
            clearInterval(messageIntervalRef.current);
            messageIntervalRef.current = setInterval(() => {
              setCurrentMessageIndex(prev_0 => (prev_0 + 1) % messages.length);
            }, messages[0].duration);
          }
        }
      };
      const handleError = () => {
        setShowVideo(false);
        setShowText(true);
      };
      video.addEventListener("loadeddata", handleLoadedData);
      video.addEventListener("error", handleError);
      return () => {
        video.removeEventListener("loadeddata", handleLoadedData);
        video.removeEventListener("error", handleError);
      };
    };
    t26 = [showVideo, showText, prefersReducedMotion, messages];
    $[49] = messages;
    $[50] = prefersReducedMotion;
    $[51] = showText;
    $[52] = showVideo;
    $[53] = t25;
    $[54] = t26;
  } else {
    t25 = $[53];
    t26 = $[54];
  }
  useEffect(t25, t26);
  let t27;
  let t28;
  if ($[55] !== prefersReducedMotion || $[56] !== videoUrl) {
    t27 = () => {
      if (prefersReducedMotion) {
        return;
      }
      const preloadVideo = document.createElement("video");
      preloadVideo.preload = "auto";
      preloadVideo.src = videoUrl;
      preloadVideo.style.display = "none";
      preloadVideo.muted = true;
      document.body.appendChild(preloadVideo);
      preloadVideo.load();
      return () => {
        if (document.body.contains(preloadVideo)) {
          document.body.removeChild(preloadVideo);
        }
      };
    };
    t28 = [videoUrl, prefersReducedMotion];
    $[55] = prefersReducedMotion;
    $[56] = videoUrl;
    $[57] = t27;
    $[58] = t28;
  } else {
    t27 = $[57];
    t28 = $[58];
  }
  useEffect(t27, t28);
  let t29;
  if ($[59] !== prefersReducedMotion || $[60] !== showVideo || $[61] !== t || $[62] !== videoUrl) {
    t29 = <div className="relative overflow-hidden rounded-lg aspect-square">{showVideo && !prefersReducedMotion ? <video ref={videoRef} autoPlay={true} muted={true} playsInline={true} loop={true} className="object-cover w-full h-full" src={videoUrl}><source src={videoUrl} type="video/mp4" /><img src="/static/images/train-journey-static.png" alt={t("aria.trip_planning")} className="object-cover w-full h-full" /></video> : <div className="flex flex-col items-center"><img src="/static/images/train-journey-static.png" alt={t("aria.trip_planning")} className="object-cover w-full h-full rounded-lg" /><div className="mt-4 text-center"><Text variant="emphasis-1" as="strong">{t("common.loading")}</Text><Text variant="body-2" as="p" id="loading-description">{t("content.loading_delay")}</Text></div></div>}</div>;
    $[59] = prefersReducedMotion;
    $[60] = showVideo;
    $[61] = t;
    $[62] = videoUrl;
    $[63] = t29;
  } else {
    t29 = $[63];
  }
  let t30;
  if ($[64] !== currentMessageIndex || $[65] !== messages || $[66] !== showText || $[67] !== t) {
    t30 = showText && <div className="mt-4 text-center"><Stack spacing={2}><Text variant="emphasis-1" as="p" aria-live="polite" aria-atomic="true">{messages[currentMessageIndex].text}</Text><Text variant="body-2" as="p">{t("content.loading_delay")}</Text></Stack></div>;
    $[64] = currentMessageIndex;
    $[65] = messages;
    $[66] = showText;
    $[67] = t;
    $[68] = t30;
  } else {
    t30 = $[68];
  }
  let t31;
  if ($[69] !== t) {
    t31 = t("content.trip_planning_description");
    $[69] = t;
    $[70] = t31;
  } else {
    t31 = $[70];
  }
  let t32;
  if ($[71] !== t31) {
    t32 = <div className="sr-only" aria-live="polite" role="status">{t31}</div>;
    $[71] = t31;
    $[72] = t32;
  } else {
    t32 = $[72];
  }
  let t33;
  if ($[73] !== t29 || $[74] !== t30 || $[75] !== t32) {
    t33 = <div className="fixed inset-0 z-[999999] flex items-center justify-center bg-black bg-opacity-60" role="dialog" aria-modal="true" aria-labelledby="loading-title" aria-describedby="loading-description"><div className="w-full max-w-md p-6 mx-4 bg-white rounded-lg shadow-lg md:mx-0">{t29}{t30}{t32}</div></div>;
    $[73] = t29;
    $[74] = t30;
    $[75] = t32;
    $[76] = t33;
  } else {
    t33 = $[76];
  }
  const loaderContent = t33;
  if (!mounted) {
    return null;
  }
  let t34;
  if ($[77] !== loaderContent) {
    t34 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const portalElement = document.getElementById("loader-portal");
      if (portalElement) {
        t34 = createPortal(loaderContent, portalElement);
        break bb0;
      }
    }
    $[77] = loaderContent;
    $[78] = t34;
  } else {
    t34 = $[78];
  }
  if (t34 !== Symbol.for("react.early_return_sentinel")) {
    return t34;
  }
  let t35;
  if ($[79] !== loaderContent) {
    t35 = createPortal(loaderContent, document.body);
    $[79] = loaderContent;
    $[80] = t35;
  } else {
    t35 = $[80];
  }
  return t35;
}